import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ResponseVideoRoutingModule } from './response-video-routing.module';
import { ResponseVideoComponent } from './response-video.component';
import { TplVideoComponent } from '../components/pliq_play/tpl-video/tpl-video.component';
import { QuestionsModule } from '../components/pliq_play/questions/questions.module';
import { ArchwizardModule } from 'angular-archwizard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ThanksMessageVideoModule } from '../components/pliq_play/thanks-message-video/thanks-message-video.module';
import { TplLoadModule } from '../components/tpl-load/tpl-load.module';

import { TplIdentifyComponent } from '../components/pliq_play/tpl-identify/tpl-identify.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ErrorModule } from '../components/error/error.module';
import { ParticipantKeyValidatorDirective } from '../core/directives/validadeParticipantKey';
import { AnimationSlideStep } from '../core/directives/animationSlideStep';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    ResponseVideoComponent,
    TplVideoComponent,
    TplIdentifyComponent,
    AnimationSlideStep
  ],
  imports: [
    CommonModule,
    ResponseVideoRoutingModule,
    QuestionsModule,
    ArchwizardModule,
    ReactiveFormsModule,
    FormsModule,
    ThanksMessageVideoModule,
    TplLoadModule,
    NgxIntlTelInputModule,
    ErrorModule,
    SharedModule
  ]
})
export class ResponseVideoModule { }
